import { useSelector } from 'react-redux';

import { selectCurrentUser } from 'features/auth/slice';

import { LinkWithButtonStyles } from '@frontendmentorio/design-system-v2';

export default function ProBanner() {
  const currentUser = useSelector(selectCurrentUser);

  if (currentUser?.hasActiveSubscription) return null;

  return (
    <div className="px-5">
      <div className="container-xl mx-auto bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl px-6 py-5 flex flex-col gap-4 text-left tablet:flex-row tablet:justify-between tablet:items-center tablet:gap-3 tablet:py-4">
        <div className="flex flex-col gap-2 text-white">
          <h2 className="font-semibold text-lg">
            Get AI-powered feedback on every solution submission
          </h2>
          <p className="text-blue-100 text-sm">
            Join thousands of developers getting personalized insights with every submission to level up faster.
          </p>
        </div>
        
        <LinkWithButtonStyles 
          href="/pro" 
          level="tertiary"
          className="text-blue-500 text-sm px-4 py-2 w-full tablet:w-auto whitespace-nowrap mx-auto tablet:mx-0"
        >
          Learn about Pro
        </LinkWithButtonStyles>
      </div>
    </div>
  );
}
